import './App.css';
import AppLogic from './components/AppLogic';


function App() {

  return (
    <AppLogic />
  );
}

export default App;
